/*
 * Yoni tabs — WAI-ARIA tabs for any [data-yoni-tabs] box (the give-back "tabs" layout).
 * The server renders every panel open and the tab bar hidden; this script wires the bar, then adds
 * .is-ready, which lets the CSS stack the panels in one cell. Without JavaScript all panels just show.
 *
 * Keys on a focused tab: Left / Right (wrapping), Home, End. Selecting follows focus, since a panel
 * appears instantly. Roving tabindex: only the selected tab is in the Tab order.
 * Theme Editor: selecting a tab block shows its panel; the boxes re-initialise on shopify:section:load.
 */
(function () {
  // The editor re-inserts this <script> when it re-renders the section: wire the new markup, but do not
  // add the document listeners a second time.
  if (window.yoniTabs) {
    window.yoniTabs.init(document);
    return;
  }

  function setup(box) {
    var tabs = [].slice.call(box.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var panels = tabs.map(function (tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    });

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].classList.toggle('is-active', on);
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var last = tabs.length - 1;
        var to = -1;
        if (e.key === 'ArrowRight') to = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft') to = i === 0 ? last : i - 1;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = last;
        if (to < 0) return;
        e.preventDefault();
        select(to, true);
      });
    });

    var selected = 0;
    tabs.forEach(function (tab, i) { if (tab.getAttribute('aria-selected') === 'true') selected = i; });
    select(selected, false);
    box.classList.add('is-ready');
    // The selected look moves from tab to tab like a jelly (assets/yoni-motion.js).
    if (window.yoniGoo) window.yoniGoo(tabs[0].parentElement, { items: '[role="tab"]', watch: true, isOn: function (t) { return t.getAttribute('aria-selected') === 'true'; } });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-yoni-tabs]').forEach(function (box) {
      if (box.dataset.yoniTabsInit === '1') return;
      box.dataset.yoniTabsInit = '1';
      setup(box);
    });
  }

  window.yoniTabs = { init: init };

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Theme Editor: selecting a "Tab" block in the sidebar shows its panel.
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('[role="tab"]') : null;
    if (tab) tab.click();
  });
})();
